import { Icon, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';

interface ILoginHeaderProps {

}

const Heading = styled(Typography.H5)`
    /* color: ${({ theme: { semantics: { palette } } }) => palette.black}; */
`;

const LoginHeadeWrapper = styled(StackPanel)`
    margin-top: 41px;
    margin-bottom: 50px !important;
`;

export function LoginHeader(props: ILoginHeaderProps) {
    return (
        <LoginHeadeWrapper width="168px" height="57px" gap="8" justifyContent="center" alignment="center" orientation="vertical">
            <Icon iconName='ap-agilepoint-logo.solid' iconSize='36' />
            <Heading>Mobile App Accelerator</Heading>
        </LoginHeadeWrapper>
    );
}
